import { CartScreen } from 'features/cart/cart-screen';
import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';

import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import { Cart } from 'pages/cart/cart';

export default function CartPage() {
  useRumPageView('cart', 'Cart');
  const enableMinimalCartUI = useMinimalCartUi();
  if (enableMinimalCartUI) {
    return <CartScreen />;
  }
  return <Cart />;
}
